<template>
  <div v-if="issue">
    <div v-if="isUnresolved && isNotSnoozed && isPlantOwner">
      <a
        style="font-weight: 500; text-decoration: none"
        @click="dialogIsOpen = true"
      >
        {{ $t('features.issues.snoozed.snooze_issue') }}
        <font-awesome-icon icon="clock" />
      </a>
    </div>
    <div v-else-if="!isNotSnoozed">
      {{ formatAsDate(new Date(issue.snoozed_until)) }}
      <a v-if="isPlantOwner" @click="unsnooze">
        <font-awesome-icon style="color: red" class="fa-fw" icon="times" @click="unsnooze"/>
      </a>
    </div>

    <snooze-issue-dialog
      v-model:visible="dialogIsOpen"
      :company-id="companyId"
      :plant-json="plantJson"
      :issue="issue"
      @fetch-required="handleFetchRequired"
    />
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import MeterIssueApi from '@/data/meters/MeterIssueApi.ts';
import type { MeterIssueJson } from '@/data/meters/MeterIssueJson.ts';
import type { PlantJson } from '@/data/plants/PlantJson.ts';
import { formatAsDate } from '@/infrastructure/support/utils/DateTimeUtils.ts';
import SnoozeIssueDialog from '@/presentation/pages/resources/cells/SnoozeIssueDialog.vue';

export default {
  name: 'SnoozedUntilCell',
  components: { SnoozeIssueDialog },
  props: {
    companyId: { type: Number, required: true },
    plantJson: {
      type: Object as PropType<PlantJson>,
      required: true,
    },
    meterIssue: { type: Object as PropType<MeterIssueJson>, required: false },
  },
  emits: ['fetch-required'],
  data() {
    return {
      dialogIsOpen: false,
      confirmDialogOpen: false,
    };
  },
  methods: {
    formatAsDate,
    handleFetchRequired() {
      this.dialogIsOpen = false;
      this.$emit('fetch-required');
    },
    unsnooze() {
      this.confirmDialogOpen = true;

      this.$confirm.require({
        header: this.$t('global.confirm_message'),
        message: this.$t('features.issues.snoozed.unsnooze_issue_confirm'),
        accept: () => {
          new MeterIssueApi()
            .unsnooze(
              this.companyId,
              this.plantJson.id,
              this.issue.meter_id,
              this.issue.id,
            )
            .then(() => this.$emit('fetch-required'));
        },
      });
    },
  },
  computed: {
    issue() {
      const isMeterIssue = this.meterIssue && this.meterIssue.meter_id;
      return this.meterIssue
        ? isMeterIssue
          ? this.meterIssue
          : null
        : this.plantJson.issue;
    },
    isUnresolved() {
      return this.issue.resolved_on === null;
    },
    isNotSnoozed() {
      return this.issue.snoozed_until === null;
    },
    isPlantOwner() {
      return this.companyId === this.plantJson.owning_company_id;
    },
  },
};
</script>

<style scoped></style>
